/**
 * Home Page
 * トップページ - ヒーロー、会社紹介、採用CTA
 */

import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen">
      <section className="relative bg-white min-h-[90vh] flex items-center overflow-hidden">
        {/* Background Image with Modern Orange Overlay */}
        <div className="absolute inset-0">
          <img
            src="/assets/images/generated_woman place right.jpeg"
            alt="Future"
            className="w-full h-full object-cover object-center"
          />
          {/* Halftone overlay - ONLY on landing image */}
          <div
            className="absolute inset-0 opacity-70 mix-blend-multiply"
            style={{
              backgroundImage: 'url(/halftones,RS社.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
          {/* Modern gradient overlay - lighter on right to show woman */}
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/70 to-transparent"></div>
          {/* Additional accent */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-transparent to-rs-orange/20"></div>
        </div>

        <div className="relative z-10 py-12 md:py-20 px-4 sm:px-8 md:pl-12 lg:pl-16">
          <div className="max-w-2xl text-left">
            <div className="inline-block mb-6 md:mb-8 px-4 md:px-6 py-2 md:py-3 bg-rs-orange/10 rounded-full border border-rs-orange/30">
              <span className="text-xs md:text-base font-semibold text-rs-orange tracking-wide">通信営業スタッフ募集中</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold mb-6 md:mb-8 leading-tight text-black">
              仕事を楽しみ、
              <br />
              人生を<span className="text-rs-orange">豊かに。</span>
            </h1>

            <p className="text-xl md:text-3xl font-light text-gray-600 mb-3 md:mb-4 tracking-wide">
              ENJOY WORK. ENJOY LIFE.
            </p>
            <p className="text-base md:text-xl text-gray-700 mb-8 md:mb-12 leading-relaxed max-w-3xl">
              人生の大部分は仕事の時間。その時間を楽しく過ごせば、人生全体の満足感もきっと向上します。<br />
              <br />
              通信事業を通じて、あなたらしい働き方と充実した人生を築きませんか。
            </p>

            <div className="flex flex-col sm:flex-row gap-4 md:gap-5 mb-12 md:mb-20">
              <Link to="/recruitment" className="inline-block bg-rs-orange text-white px-8 md:px-10 py-3 md:py-3.5 rounded-full font-medium hover:bg-rs-orange-light active:scale-[0.98] transition-all duration-200 text-sm md:text-base text-center">
                採用エントリー
              </Link>
              <Link to="/about" className="inline-block border border-gray-300 text-gray-700 px-8 md:px-10 py-3 md:py-3.5 rounded-full font-medium hover:border-gray-400 hover:bg-gray-50 active:scale-[0.98] transition-all duration-200 text-sm md:text-base text-center">
                会社について
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 3つの強み */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center mb-16">
            <span className="inline-block text-sm font-semibold text-rs-orange uppercase tracking-wider mb-4 px-4 py-2 bg-rs-orange/10 rounded-full">WHY JOIN US</span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
              RSで働く <span className="text-rs-orange">3つの強み</span>
            </h2>
            <p className="text-gray-700 text-lg max-w-2xl mx-auto">
              あなたの成長をサポートする環境がここにあります
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Point 1 - Growth Environment */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl hover:shadow-2xl hover:border-rs-orange hover:-translate-y-2 transition-all duration-300 group overflow-hidden">
              <div className="relative h-56 overflow-hidden">
                <img
                  src="/assets/images/happy_two_workers.jpeg"
                  alt="成長できる環境"
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-rs-orange/50 via-rs-orange/30 to-transparent mix-blend-multiply"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold mb-4 text-black group-hover:text-rs-orange transition-colors">成長できる環境</h3>
                <p className="text-gray-700 leading-relaxed text-base">
                  実践的な研修とサポート体制で、未経験からでもプロフェッショナルへと成長できます。
                </p>
              </div>
            </div>

            {/* Point 2 - Teamwork */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl hover:shadow-2xl hover:border-rs-orange hover:-translate-y-2 transition-all duration-300 group overflow-hidden">
              <div className="relative h-56 overflow-hidden">
                <img
                  src="/assets/images/discussion_meeting.jpeg"
                  alt="チームワーク"
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-tl from-rs-orange/50 via-rs-orange/30 to-transparent mix-blend-multiply"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold mb-4 text-black group-hover:text-rs-orange transition-colors">チームワーク</h3>
                <p className="text-gray-700 leading-relaxed text-base">
                  仲間と協力しながら、一緒に目標を達成する喜びを実感できる職場です。
                </p>
              </div>
            </div>

            {/* Point 3 - Benefits */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl hover:shadow-2xl hover:border-rs-orange hover:-translate-y-2 transition-all duration-300 group overflow-hidden">
              <div className="relative h-56 overflow-hidden">
                <img
                  src="/assets/images/handshake_future.jpeg"
                  alt="充実の待遇"
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-tr from-rs-orange/50 via-rs-orange/30 to-transparent mix-blend-multiply"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold mb-4 text-black group-hover:text-rs-orange transition-colors">充実の待遇</h3>
                <p className="text-gray-700 leading-relaxed text-base">
                  頑張りを正当に評価し、安心して働ける環境を提供します。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
